import { Injectable, computed, signal } from '@angular/core';

export type DeviceType = 'desktop' | 'mobile';

const MOBILE_BREAKPOINT = 1024;

const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 0.02}px)`;

@Injectable({ providedIn: 'root' })
export class DeviceService {

  private readonly _isMobile = signal<boolean>(
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY).matches : false
  );

  /** Signal public — 'desktop' | 'mobile' */
  readonly device = computed<DeviceType>(() => this._isMobile() ? 'mobile' : 'desktop');

  readonly isMobile  = computed(() => this._isMobile());
  readonly isDesktop = computed(() => !this._isMobile());

  constructor() {
    if (typeof window === 'undefined') return; // SSR guard

    const query = window.matchMedia(MOBILE_QUERY);
    query.addEventListener('change', event => this._isMobile.set(event.matches));

    window.addEventListener('resize', () => this._isMobile.set(query.matches));
  }
}
